import React from 'react';
import RepositoryScheduleTable from './repoSelectTable';

const ScheduleScanPanel = () => {
  return <RepositoryScheduleTable />;
};

export default ScheduleScanPanel;
